<div class="wrapper">
    <div class="input-wrapper searchbar">
      @if (this.searchQuery.value != null && this.searchQuery.value != '') {
      <mat-icon class="search-icons red" (click)="clearSearch()" matTooltip="Clear" matTooltipShowDelay="500">clear</mat-icon>
      }
      <input class="searchbar" matInput [placeholder]="'Search Session'" [formControl]="searchQuery" (keyup.enter)="submitRefresh()" [tabindex]="'-1'" />
      <mat-icon class="search-icons" (click)="submitRefresh()" matTooltip="Search" matTooltipShowDelay="500">search</mat-icon>
    </div>
  
  <div class="session">
    <div class="default">
      <div class="default-session">
        {{data.groupName}}
        <button 
          class="set-as-default"
          (click)="onGroupAction({ title: 'Set as Default', row: { ID: currentGroup } })"
          [disabled]="currentGroup === currentDefaultGroup">
          {{ currentGroup === currentDefaultGroup ? 'Default Group' : 'Set as Default' }}
        </button>
      </div>
    </div>
    @if(groups != null && groups.length  > 0 && !loading)
    {
      <div class="table">
        @for (group of groups; track group; let i = $index) {
          <mat-list-item class="group" lines="none" >
            <div class="group-container">
              <mat-label class="label">{{ group['Name'] }}</mat-label>
              <div class="button-container">
                <button 
                  class="first-button" 
                  mat-button
                  (click)="onGroupAction({ title: 'Change Session', row: { ID: group.ID } })">
                  <mat-icon>
                    <img [src]="path + 'change_session_default.svg'" alt="Change Session">
                  </mat-icon>
                </button>
                <button 
                  mat-button>
                  <mat-icon>
                    <img [src]="path + 'open_in_new_default.svg'" alt="Open in New">
                  </mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
        }
      </div>
    } @else {
      <div class="loading-container">
        <mat-spinner color="primary"></mat-spinner>
      </div>
    }
  </div>
	
  <div class="buttons">
    <button class="session-button" mat-raised-button (click)="navigateTo('/Home/ChangeSession')" tabindex="-1">
      More Sessions
    </button>
    <button mat-raised-button (click)="closeModal()" tabindex="-1">
      Close
    </button>
  </div>

</div>